export default __webpack_public_path__ + "static/media/undo-icon.79c6425d.svg";